// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kH-z","twoColumnImage":"lH-z"};